import { ToastBody } from './_ToastBody';
import toast, { Toaster } from 'react-hot-toast';
import { onPositionNative } from './_toastPosition';

/*
    🔥 TOAST — react-hot-toast

    toast.custom da control total del render, así que el cuerpo es
    el mismo que el de las otras cinco.
*/

export const AlertHotToastHost = ({ position }) => (
    <Toaster position={onPositionNative(position)}
        containerClassName="LStudio__app_toast_container"
        toastOptions={{ duration: 4000, style: { padding: 0, background: 'none', boxShadow: 'none', maxWidth: 'none' } }} />
);

export const onNotifyHotToast = ({ type = 'info', title, text, autoClose }) => (

    toast.custom(
        (item) => <ToastBody type={type} title={title} text={text} onClose={() => toast.dismiss(item.id)} />,
        { duration: autoClose || 4000 },
    )
);
